import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

interface LoaderProps {
  message?: string;
  size?: number;
}

const Loader: React.FC<LoaderProps> = ({ message, size = 40 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.7)"
      }}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            textAlign: "center",
            maxWidth: "80%"
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;